var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.is_mem_load
    ? _c(
        "div",
        { staticClass: "memorandum_action" },
        [
          _c("work_users_block"),
          _vm._v(" "),
          _c("adjust_editor"),
          _vm._v(" "),
          _c("invoice_editor"),
          _vm._v(" "),
          _c("adjust_replace"),
          _vm._v(" "),
          _c("legend", [_vm._v("Обробка")]),
          _vm._v(" "),
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "b-tab",
                {
                  key: index,
                  attrs: {
                    disabled: tab.disabled,
                    title: _vm.get_tab_title(tab),
                    active: tab.is_active,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.set_active(index)
                    },
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.get_tab_title(tab)) +
                          "\n                "
                      ),
                      tab.is_load
                        ? _c("b-spinner", {
                            attrs: { type: "grow", small: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(index, {
                    tag: "component",
                    attrs: { doc_id: _vm.mem_id },
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }